import { isNil } from '@/utils';

export interface PageQuery {
  pageNum: number;
  pageSize: number;
}

// 获取项目列表参数
export interface GetProjecPageListQuery extends PageQuery {
  name?: string;
  /**
   * undefind | gourpId like "prgxxxxxx" | null,
   * null='全部项目'菜单项，undefind等于什么都不选
   */
  groupId?: string | null;
  deleted?: boolean;
}

export const queryKeys = {
  project: (id?: string) => ['project', id],
  scene: (projectId?: string) => ['scene', projectId], // 场景配置key
  officialModelCategory: () => ['officialModelCategory'],
  officialModel: (categoryId?: number, pageNum?: number, pageSize?: number) => [
    'officialModel',
    categoryId,
    pageNum,
    pageSize,
  ],
  userAssets: () => ['userAssets'],
  userInfo: () => ['userInfo'],
  projectList: (query?: GetProjecPageListQuery) => {
    if (isNil(query)) {
      return ['projectList'];
    } else
      return [
        'projectList',
        query.pageSize,
        query.pageNum,
        query.groupId,
        query.deleted,
        query.name,
      ];
  },
  videoProjects: () => ['videoProjects'],
  projectCount: () => ['projectCount'],
  projectGroupList: () => ['projectGroupList'], // 分组列表
  entityList: (sceneId?: string) => ['entityList', sceneId], // 实体列表，预览用
  spaces: () => ['spaces'],
  feedbacks: (spaceId?: string | number) => ['feedbacks', spaceId],
  sceneResource: (sceneId?: string) => ['sceneResource', sceneId],
  matList: (sceneId?: string) => ['sceneResourcesMat', sceneId],
  histroyVersions: () => ['histroyVersions'],
  accessKeyList: () => ['AccessKeyList'],
  accessKey: (userId: number) => ['AccessKeyList', userId],
  customComponents: () => ['customCompoenents'],
};
